import packageInfo from '../../package.json';

export const environment = {
  production: true,
  apiUrl: 'https://backend.pampamed.com.ar',
  version: packageInfo.version,
};
